/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const filtersPanel = document.querySelector('.collection__filters');

  // Event delegation per il pulsante di chiusura
  document.addEventListener('click', function (event) {
    if (event.target.matches('.collection__filters__chiudi svg')) {
      filtersPanel.classList.remove('is-visible');
    }
  });

  // Pulsante per aprire i filtri
  const toggleButton = document.querySelector('.collection__filters-toggle-btn');
  if (toggleButton && filtersPanel) {
    toggleButton.addEventListener('click', () => {
      filtersPanel.classList.add('is-visible');
    });
  }

// Componente per il form della richiesta fattura a carrello
class InvoiceFields extends HTMLElement {
  static E = {
    activate: '[data-activate]',
    type: '[data-select-type]',
    collapses: '[data-type]',
    accordion: '[data-accordion]'
  }
  activateCheckbox; // checkbox per attivare la richiesta fattura
  typeSelect;       // select per selezionare il tipo di fattura
  accordion;        // accordion che contiene i campi della fattura
  collapses;        // blocchi contenenti i campi di ogni tipo di fattura
  active = false;   // flag per la visualizzazione dei campi
  type;             // tipo di fattura selezionato

  connectedCallback() {
    this.init();
  }

  // affibbia i listener agli elementi
  init = () => {
    this.activateCheckbox = this.querySelector(InvoiceFields.E.activate);
    this.typeSelect = this.querySelector(InvoiceFields.E.type);
    this.accordion = this.querySelector(InvoiceFields.E.accordion);
    this.collapses = this.querySelectorAll(InvoiceFields.E.collapses);

    this.type = this.typeSelect.value;

    this.activateCheckbox.addEventListener('change', this.activate.bind(this));
    this.typeSelect.addEventListener('change', this.changeType.bind(this));
  }

  // attiva la richiesta fattura visualizzando i campi
  activate = () => {
    this.active = !this.active;

    //apro visualizzo i campi
    this.accordion.classList.toggle('open', this.active);

    //se attivo cambio il tipo di fattura
    if(this.active)
      this.changeType();
    else
      this.deactivate();
  }

  // modifica il tipo di fattura impostando i campi obbligatori
  changeType = () => {
    this.type = this.typeSelect.value;
    const collapse = this.querySelector(`[data-type="${this.type}"]`);

    //nascondo tutti i collapse
    this.deactivate();

    //aggiungo i required ai campi del tipo selezionato
    collapse.querySelectorAll('[data-required]').forEach((el) => {
      el.setAttribute('required', true);
    });

    // mostro il collapse
    collapse.classList.add('open');
  }

  // rimuove tutti i required e nasconde tutti i blocchi tipologia
  deactivate = () => {
    this.querySelectorAll('[required]').forEach((el) => {
      el.removeAttribute('required');
      el.value = '';
    });
    this.collapses.forEach((el) => {
      el.classList.remove('open');
    });
  }
}
if(window.customElements) {
  window.customElements.define('invoice-fields', InvoiceFields);
}

// cart counter component

class CartCounter extends HTMLElement {

  connectedCallback() {
    document.addEventListener('theme:cart:added', this.refresh.bind(this));
    document.addEventListener('theme:cart:update', this.refresh.bind(this));
  }

  refresh = () => {
    fetch(location.href)
      .then(response => response.text())
      .then(text => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const counter = doc.querySelector('cart-counter');
        if(counter){
          this.innerHTML = counter.innerHTML;
        }
      });
  }

}
if(!customElements.get('cart-counter')){
  customElements.define('cart-counter', CartCounter);
}



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
